/* eslint-disable @typescript-eslint/camelcase */
import { AnyAction }  from 'redux';
import { EUserRole }  from '@enums/common';
import { IRootState } from '@store/rootReducer';
import {
  LOGIN_SUCCEED,
  LOGOUT_SUCCEED,
  FETCH_AUTH_INFO_SUCCEED,
}                     from './authActions';

export interface IAuthUser {
  id            : string | null;
  role          : EUserRole | null;
  access_token  : string | null;
  refresh_token : string | null;
}

const AUTH_KEYS = {
  ID   : 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier',
  ROLE : 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
};

const initState: IAuthUser = {
  id            : null,
  role          : null,
  access_token  : null,
  refresh_token : null,
};

/** REDUCERS */
const loginSucceed = (state = initState, action: AnyAction): IAuthUser => ({
  ...state,
  access_token  : action.payload.access_token,
  refresh_token : action.payload.refresh_token,
});

const logoutSucceed = (): IAuthUser => initState;

const fetchAuthInfoSucceed = (state = initState, action: AnyAction): IAuthUser => ({
  ...state,
  id   : action.payload[AUTH_KEYS.ID],
  role : action.payload[AUTH_KEYS.ROLE],
});

/** REDUCERS */

const strategies = {
  [LOGIN_SUCCEED]           : loginSucceed,
  [LOGOUT_SUCCEED]          : logoutSucceed,
  [FETCH_AUTH_INFO_SUCCEED] : fetchAuthInfoSucceed,
  defaultState              : (state: IAuthUser): IAuthUser => state,
};

export const auth = (state = initState, action: AnyAction): IAuthUser => {
  const transformer = strategies[action.type] ?? strategies.defaultState;
  return transformer(state, action);
};

/** SELECTORS */
export const getToken        = (state: IRootState): string => state.auth.access_token ?? '';
export const getAuthUser     = (state: IRootState): IAuthUser => state.auth ?? null;
export const getIsAuthorized = (state: IRootState): boolean => !!state.auth.access_token ?? false;
/** SELECTORS */
